module.exports = __webpack_public_path__ + "static/media/chat10.a31f2d2d.svg";